import { StandardGrid, StandardGridPresentationType } from '@apply/components';
import { Column } from 'devextreme-react/data-grid';
import { formatEmailLink } from './functions/formatEmailLink';
import { BridgeApplication } from '../../mockData/mockApplicationsGridData';

export interface IncompleteGridProps {
    data: BridgeApplication[];
}

export const IncompleteGrid = ({ data }: IncompleteGridProps) => {
    return (
        <>
            <StandardGrid
                dataSource={data}
                keyExpr='applicationId'
                presentationType={StandardGridPresentationType.EnhancedDeemphasized}
                noDataText='No Incomplete Applications Found'
                pagerVisible={false}
                rowAlternationEnabled={true}
                showColumnHeaders={true}
                remoteOperations={false}
            >
                <Column
                    dataField='borrower'
                    caption='Borrower'
                    alignment='left'
                />
                <Column
                    dataField='city'
                    caption='City'
                    width={250}
                    alignment='left'
                />
                <Column
                    dataField='state'
                    caption='State'
                    width={120}
                    alignment='left'
                />
                <Column
                    dataField='lastUpdated'
                    caption='Last Updated'
                    width={200}
                    alignment='left'
                    dataType='date'
                    format='M/dd/yyyy'
                />
                <Column
                    dataField='broker'
                    caption='Broker'
                    width={200}
                    alignment='left'
                />
                <Column
                    dataField='user'
                    caption='User'
                    width={200}
                    alignment='left'
                />
                <Column
                    dataField='userEmail'
                    caption='User Email'
                    width={350}
                    alignment='left'
                    cellRender={(e) => formatEmailLink(e.value)}
                />
                <Column
                    dataField='poc'
                    caption='POC'
                    alignment='left'
                    width={100}
                />
            </StandardGrid>
        </>
    );
};
